import type { LocalServiceRow } from '../../devenvbootstrap/framework';

type Props = { items?: LocalServiceRow[] };

export function LocalServicesPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.service} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.service}</p>
            <span className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${item.status === 'required' ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300'}`}>
              {item.status}
            </span>
          </div>
          <p className="mt-1 font-mono text-xs text-slate-500">:{item.port} · {item.image}</p>
        </div>
      ))}
    </div>
  );
}
